import { render, staticRenderFns } from "./actions.vue?vue&type=template&id=a0ff44ba&scoped=true"
import script from "./actions.vue?vue&type=script&lang=js"
export * from "./actions.vue?vue&type=script&lang=js"
import style0 from "./actions.vue?vue&type=style&index=0&id=a0ff44ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ff44ba",
  null
  
)

export default component.exports